













import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EchartOption from '@/common/const/e-chart-options';
import CustomTab from './custom-tab/index.vue';
import * as api from '@/api/business-overview';

@Component({
  components: { CustomTab }
})
export default class AbnormalStatistics extends Vue {
  @Prop({ default: 0 })
  type?: number;

  @Prop({ default: () => [] })
  orgIds: any[];

  @Prop()
  parkId?: String;

  timeTypeTabs: any[] = [
    {
      label: '昨日',
      value: 'yesterday'
    },
    {
      label: '本周',
      value: 'week'
    },
    {
      label: '本月',
      value: 'month'
    }
  ];

  timeType: number = 0;

  @Watch('orgIds')
  @Watch('parkId')
  @Watch('timeType')
  needRefresh() {
    this.init();
  }

  options: EchartOption = new EchartOption();
  isData: boolean = true;

  yAxisData: string[] = [];
  seriesBarData: number[] = [];

  get title() {
    return {
      show: false
    };
  }

  get toolTip() {
    return {};
  }

  get grid() {
    return {
      top: '8%',
      left: '5%',
      right: '5%',
      bottom: '5%',
      containLabel: true
    };
  }

  get legend() {
    return {
      show: true,
      bottom: 0,
      itemWidth: 15,
      icon: 'roundRect'
    };
  }

  get xAxis() {
    return {
      type: 'value',
      boundaryGap: true,
      axisLabel: {
        color: '#D8D8D8'
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      }
    };
  }

  get yAxis() {
    return [
      {
        type: 'category',
        inverse: true,
        axisLabel: {
          show: true,
          color: '#000'
        },
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        data: ['异常操作']
      }
    ];
  }

  get series() {
    return this.seriesBarData.map((v, i) => {
      return {
        name: this.yAxisData[i],
        type: 'bar',
        barWidth: 50,
        data: [v]
      };
    });
  }

  async fetchChartData() {
    const timeTypeValue = this.timeTypeTabs[this.timeType].value;
    let param;
    if (this.type == 0) {
      param = {
        type: timeTypeValue,
        orgIds: this.orgIds
      };
    } else {
      param = {
        type: timeTypeValue,
        parkId: this.parkId
      };
    }
    try {
      const { data } = await api.queryAbnormalStatistics(param);
      // todo 临时屏蔽
      const data2 = data.filter((i: { name: string }) => i.name != '跟车出场' && i.name != '被冲出场');
      this.seriesBarData = data2.map((i: { num: any }) => i.num);
      this.yAxisData = data2.map((i: { name: any }) => i.name);
    } catch (e) {
      console.log(e);
    } finally {
      this.refreshChart();
    }
  }

  refreshChart() {
    const options: EchartOption = new EchartOption();
    options.setLegend(this.legend);
    options.setGrid(this.grid);
    options.setXAxis(this.xAxis, true);
    options.setYAxis(this.yAxis, true);
    options.setTitle(this.title);
    options.setSeries(this.series);
    options.setTooltip(this.toolTip);
    options.setColor(['#36cbcb', '#975fe4', '#3aa0ff', '#fad337', '#f2637b']);
    this.options = options;
  }

  init() {
    this.fetchChartData();
  }

  mounted() {
    this.init();
  }
}
